export default "__VITE_ASSET__DNPf09RK__"